<template>
  <div class="navigator flex-middle-x layout-flex-justify-content_space-between" :style="{borderBottom:borderBottom}">
    <div class="go-back flex-middle-x">
      <p v-if="goBackContent">首页</p>
      <img v-if="goBackImg" :src="navigatorLeftImg" alt="" @click="skipBack">
    </div>
    <div class="theme">
      <p v-if="headLine" class="pds-beyond-ellipsis">{{headLine}}</p>
    </div>
    <div class="jump">
      <p v-if="jumpContent">完成</p>
      <img v-if="collect" :src="collectImg" alt="" @click="actionCollect">
    </div>
  </div>
</template>
<script>
  export default {
    name:'',
    data(){
      return {
        collectImg: require('./image/cinema-collect-img.png')
      }
    },
    computed: {
      navigatorLeftImg: function () {
        if (this.navigatorImgType === 1) {
          return require('../assets/icons/widget/navigator-left-white.png');
        }
        return require('../assets/icons/widget/navigator-left-gray.png');
      }
    },
    props:{
      borderBottom: {
        type: String,
        default: '1px solid #dddddd'
      },
      navigatorImgType: {
        default: 0
      },
      headLine:String,
      goBackContent: {
        default: false
      },
      goBackImg: {
        default: true
      },
      themeContent: {
        default: true
      },
      jumpContent: {
        default: false
      },
      navigatorCallback: {
        type: Function
      },
      collect: {
        type: false
      }
    },
    methods:{
      skipBack: function () {
        if (this.navigatorCallback) {
          this.navigatorCallback();
        } else {
          window.history.back();
        }
      },
      actionCollect: function () {
        this.$emit('actionCollect');
      }
    },
    mounted(){
    }
  }
</script>
<style lang="scss" rel="stylesheet/scss" scoped>
  @import "../assets/styles/index.scss";
  .navigator{
    width:100%;
    height:0.88rem;
    position: fixed;
    top:0;left:0;
    font-size:0.36rem;
    color:black;
    z-index:10000;
    padding:0 0.2rem;
    background:$color-4;
    .go-back{
      img{
        width:0.2rem;
      }
    }
    .theme{
      p{
        width:6rem;
        font-size:0.36rem;
        color:black;
      }
    }
    .jump{
      font-size:0.26rem;
      color:$color-red;
      img{
        width:0.45rem;
      }
    }
  }
</style>
